export const checkIsEditable = (field: LocalCustomField, advanced: boolean) => {
  const allowedTypes: LocalCustomField['field_type'][] = [
    'boolean',
    'multiselect',
    'dropdown',
    'date-only',
    'date-time',
    'month-year',
    'user'
  ]

  if (advanced) {
    allowedTypes.push('text', 'multiline', 'phone')
  }

  return allowedTypes.includes(field.field_type)
}
